export default __webpack_public_path__ + "static/media/bold_icon_grey.a723edd1.svg";